import React, { Component } from 'react';
import Input from '../../stateless/common/Input/Input';
import Button from '../../stateless/common/CommonButton/Button';
import classes from './Authentication.module.css';
import {connect} from 'react-redux';
import * as actionTypes from '../../redux-store/redux-actions/redux-actions';
import Spinner from '../../stateless/common/Spinner/Spinner';
import Wrapper from '../../wrapper/Wrapper';
import {withRouter, Redirect } from 'react-router-dom';
import Toastr from '../../stateless/common/Toastr/Toastr';

class Authentication extends Component{

    state = {
        isSignUp : false,
        inValid : true,
        form : [
            {
                element : 'email',
                elementType : 'input',
                elementConfig : {
                    placeholder : 'Your E-Mail',
                    type : 'email'
                },
                value : '',
                validation : {
                    required : true
                },
                isValid : false,
                isTouched : false
            },
            {
                element : 'password',
                elementType : 'input',
                label: 'Password',
                elementConfig : {
                    placeholder : 'Password',
                    type : 'password'
                },
                value : '',
                validation : {
                    required : true,
                    minlength : 6
                },
                isValid : false,
                isTouched : false
            }
        ]
    }

    validCheck(value , rules){
        let isValid = false;

        if(rules.required){
            isValid = value.trim() !== '';
        }

        if(rules.minlength){
            isValid = value.length >= rules.minlength && isValid;
        }


        return isValid;
    }

    onChangeHandler = (event,index) => {
        let updatedForm = [...this.state.form];
        let getValue = {...updatedForm[index]};
        getValue['value'] = event.target.value;
        getValue['isValid'] = this.validCheck(getValue['value'],getValue['validation']);
        getValue['isTouched'] = true;
        updatedForm[index] = getValue;
        let validArray = updatedForm.filter(value => !value.isValid);
        let invalid = validArray.length > 0;
        this.setState({form:updatedForm , inValid:invalid});
    }

    authHandler = (event) => {
        event.preventDefault();
        this.props.onAuthStart(this.state.form[0].value,this.state.form[1].value,
            this.state.isSignUp);
    }

    onAuthHandler = () => {
        this.setState((prevstate) => {
            return {
                isSignUp : !prevstate.isSignUp
            }
        })
    }

    closeHandler = () => {
        this.props.removeHandler();
    }

    render(){
        
        let shouldToastrShown = this.props.error ? 
            <Toastr severity="error" color="error"
                    open={this.props.error}
                    content={this.props.error.message}
                    closeHandler={this.closeHandler}/> : null;
        
        return(
            <div className={classes.Auth}>
                {shouldToastrShown}
                {this.props.loading ? <Spinner></Spinner> : 
                this.props.token ? 
                <Redirect to='/burgerBuilder'/> :
                <Wrapper>
                    <form onSubmit={this.authHandler}>
                    {
                        this.state.form.map((elements,index) => {
                            return <Input key={elements.element} 
                                elementType={elements.elementType} 
                                elementConfig={elements.elementConfig} 
                                value={elements.value}
                                changed={(event) => this.onChangeHandler(event,index)}
                                required={elements.validation.required}
                                shouldValidate = {elements.validation}
                                isTouched = {elements.isTouched}
                                inValid = {!elements.isValid}
                            />
                        })
                    }
                    <Button type="Success" disabled={this.state.inValid}>
                        {this.state.isSignUp ? 'Sign Up' : 'Sign In'}</Button>
                </form>
                <Button type="Danger" 
                    clicked={this.onAuthHandler}>
                    {!this.state.isSignUp ?
                     'Switch to Sign Up' :
                     'Switch to Sign In'}
                </Button>
                </Wrapper>
            }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.AuthReducer
    }
}

const mapDispatchwithProps = (dispatch) => {
    return {
        onAuthStart : (email, password , isSignUp) => dispatch(actionTypes.onAuth(email,password,isSignUp)),
        removeHandler : () => dispatch({type: actionTypes.REMOVE_ERROR})
    }
}

export default connect(mapStateToProps,mapDispatchwithProps)(withRouter(Authentication));